import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import HeroObjectSelector from "TaskDialogCommon/HeroObjectSelector";

const taskname = "wallremover";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    this.state = {
      taskConfig: {
        accountdetail: accountdetailrow,
        action: "addToService",
        selectedhero: {},
        troops: {},
        unboxtroops: true,
      },
    };
  }

  validate = () => {
    const {
      taskConfig: { selectedhero, troops },
    } = this.state;
    if (!selectedhero || Object.keys(selectedhero).length === 0) {
      alert("Please select a hero before continuing");
      return false;
    }
    if (!troops || Object.keys(troops).length === 0) {
      alert("Please select troops to use before continuing");
      return false;
    }
    return true;
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    return (
      <TaskDialog heading={"Set Wall Remover"}>
        <HeroObjectSelector
          label={"Select Hero"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"selectedhero"}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send"}
          param={"troops"}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Create Wall Remover"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
